import { Program } from "src/app/model/program";
import { OperationHour } from "src/app/model/operationHour";

export class OrganizationInfo {
    constructor(
        public OrganizationGuid: string = '',
        public OrganizationName: string = '',
        public ContactPersonName: string = '',
        public ContactPersonEmailAddress: string = '',
        public ContactPersonPhone: string = '',
        public PublicEmail: string = '',
        public Phone: string = '',
        public Street: string = '',
        public City: string = '',
        public State: string = '',
        public Zip: string = '',
        public Country: string = '',
        public URL: string = '',
        public Hours: string = '',
        public Type: string = '',
        public FoundedOn: string = '',
        public LicNo: string = '',
        public MissionStatement: string = '',
        public EIN: string,
        public IsCourtAppointedServicesAccepted: string,
        public IsCommunityServiceCreditQualified: string,
        public IsActiveGenralLiabilityPolicy: string,
        public IsLogoUploaded: boolean = false,
        public LogoFileName: string = '',
        public IsInsuranceLoaded: boolean = false,
        public InsuranceFileName: string = '',
        public InsuranceNumber: string = '',
        public InsuranceCompanyName: string = '',
        public Status: string = '',
        public OperationHours: OperationHour[],
        public Programs: Program[]
    ) { }
}
